import { FR } from './france';

export const YT = FR;
